module.exports = __webpack_public_path__ + "static/media/Alrajhi Bank.04f36950.svg";